<template>
    <div id="goTop">
      <div class="goTop" v-show="goTopShow" @click="goTop"><i class="goTopIcon"></i></div>
    </div>
</template>

<script>
export default {
      name: "goTop",
      data(){
          return{
            scrollTop: '',
            goTopShow:false,
          }
        },
      methods:{
        handleScroll () {
          
          this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
          if(this.scrollTop>200){
            this.goTopShow=true
          }
        },
        goTop(){
           
          let timer=null,_that=this;
          cancelAnimationFrame(timer)
          timer=requestAnimationFrame(function fn(){
            if(_that.scrollTop>0){
              _that.scrollTop-=50;
              document.body.scrollTop = document.documentElement.scrollTop = _that.scrollTop;
              timer=requestAnimationFrame(fn)
            }else {
              cancelAnimationFrame(timer);
              _that.goTopShow=false;
            }
          })
        }
      },
      mounted() {
        this.$nextTick(function () {
        //修改事件监听
        window.addEventListener('scroll', this.handleScroll,true);
        
      });
      },
      destroyed(){
        window.removeEventListener('scroll', this.handleScroll,true);
      }
    }
</script>

<style>
.goTop{
    
    position: fixed;
    right: 10px;
    bottom: 90px;
    z-index: 999;
  }
  .goTopIcon{
    display: block;
    width: 70px;
    height: 70px;
    background-image: url("../../assets/img/goToTop.png");
    background-size: contain;
}
</style>



// WEBPACK FOOTER //
// src/packages/gotop/index.vue